import { ENDPOINTS } from '@/api/endpoints';
import { fetchClient } from '@/api/fetch-client';
import {
  OmniLlmAddendumSummaryRequest,
  OmniLmlFinalImpressionSuggestionRequest,
} from '@/api/model';

const request = {
  postAddendumSummary: async (
    { payload: { reportUuid, studyId } }: OmniLlmAddendumSummaryRequest,
    signal?: AbortSignal,
  ): Promise<ReadableStreamDefaultReader<Uint8Array> | undefined> => {
    const response = await fetchClient.FCT.sse(
      `${ENDPOINTS.FCT.OMNI_LLM.GENERATE_ADDENDUM_SUMMARY}/${reportUuid}`,
      { params: { studyId }, signal },
    );

    if (!response.body) {
      return undefined;
    }

    return response.body.getReader();
  },
  postFinalImpressionsSuggestion: async (
    { payload: { reportUuid } }: OmniLmlFinalImpressionSuggestionRequest,
    signal?: AbortSignal,
  ): Promise<ReadableStreamDefaultReader<Uint8Array> | undefined> => {
    const response = await fetchClient.FCT.sse(
      `${ENDPOINTS.FCT.OMNI_LLM.GENERATE_FINAL_IMPRESSION}/${reportUuid}`,
      { signal },
    );

    if (!response.body) {
      return undefined;
    }

    return response.body.getReader();
  },
};

export const omniLlm = {
  request,
};
